import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./BattleResultView.module.scss"
import { IBattleResultViewProps } from "./types"

const BattleResultViewComponent: FC<IBattleResultViewProps> = ({
  titleKey,
  reasonKey,
  onOk
}) => {
  const { t } = useTranslation("battle")

  return (
    <div className={styles.BattleResultView}>
      <h2 className={styles.BattleResultView_title}>{t(titleKey)}</h2>
      {reasonKey && (
        <span className={styles.BattleResultView_reason}>{t(reasonKey)}</span>
      )}
      <button
        type="button"
        className={styles.BattleResultView_ok}
        onClick={onOk}
      >
        {t("result.ok")}
      </button>
    </div>
  )
}

export const BattleResultView = memo(BattleResultViewComponent)
